import imgCityScape from './assets/images/london-cityscape.svg'

import theme from './theme.js'

export default {
	featured: {
		background: theme.palette.secondary.light,
		padding: '2rem 0 0'
	},
	featuredColumn: {
		background: 'rgb(44, 46, 51)',
		borderRadius: '3px',
		padding: '1rem 2rem 2rem',
		color: 'white'
	},
	featuredDark: {
		background: theme.palette.secondary.main,
		padding: '2rem 0 5rem'
	},
	heading: {
		color: 'black',
		width: '45vw'
	},
	content: {
		color: theme.palette.secondary.contrastText,
		maxWidth: '1200px',
		textAlign: 'center',
		width: theme.breakpoints.values.md <= window.innerWidth ? '60vw' : '90vw'
	},
	center: {
		textAlign: 'center'
	},
	contentDark: {
		background: theme.palette.secondary.dark,
		color: theme.palette.secondary.light,
		padding: '5rem .5rem'
	},
	contentLight: {
		background: theme.palette.secondary.light,
		color: theme.palette.secondary.dark,
		padding: '5rem .5rem'
	},
	panel: {
		padding: '2rem 0'
	},
	slides: {
		width: '100vw'
	},
	slide: {
		color: 'white',
		fontFamily: 'Open Sans',
		fontSize: '3rem',
		fontWeight: 400,
		height: '100vh',
		textAlign: 'center',
		textShadow: '1px 3px 5px black'
	},
	footer: {
		background: `url(${imgCityScape})`,
		backgroundPosition: 'top center',
		backgroundRepeat: 'repeat-x',
		backgroundSize: 'auto',
		paddingTop: '130px'
	},
	footerContent: {
		color: theme.palette.secondary.light,
		fontSize: '.8rem',
		textAlign: 'left'
	}
}


// WEBPACK FOOTER //
// ./src/styles.js